var s = class extends HTMLElement {
  connectedCallback() {
    this.isExpanded = false;
    this.shortDesc = this.querySelector("#short-description");
    this.longDesc = this.querySelector("#long-description");
    this.button = this.querySelector(".read-more-btn");

    if (!this.shortDesc || !this.longDesc || !this.button) return;
    this.button.addEventListener("click", () => this.toggle());
  }

  toggle() {
    var t, e;
    this.isExpanded = !this.isExpanded;
    this.shortDesc.classList.toggle("hidden", this.isExpanded);
    this.shortDesc.classList.toggle("block", !this.isExpanded);
    this.longDesc.classList.toggle("hidden", !this.isExpanded);
    this.longDesc.classList.toggle("block", this.isExpanded);
    this.button.textContent =
      ((e = (t = window.theme)?.translations) ?.[this.isExpanded ? "product.read_less" : "product.read_more"]) ||
      (this.isExpanded ? "Read less" : "Read more");
  }
};

customElements.define("description-expander", s);
